import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { UniHeader } from "./_lmsShared";
import { Loader2, Award, Calendar, ExternalLink } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/university`;

const STATUS_TONE = {
  active: "bg-emerald-100 text-emerald-800",
  advisory: "bg-amber-100 text-amber-800",
  emeritus: "bg-purple-100 text-purple-800",
};

export default function UniversityBoard() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await axios.get(`${API}/alumni/board`);
        setItems(r.data?.items || []);
      } catch (e) { toast.error("Could not load board"); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#FBF8F2]">
      <UniHeader title="University Board" back="/university" />
      <main className="max-w-5xl mx-auto px-6 py-10" data-testid="uni-board">
        <h1 className="font-display text-4xl text-slate-900">KISSED University Board</h1>
        <p className="mt-2 text-sm text-slate-600 max-w-2xl">
          Governance and advisory leadership for KISSED University of Healing Arts &amp; Sciences.
        </p>

        {loading ? (
          <div className="mt-8 text-slate-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Loading…</div>
        ) : items.length === 0 ? (
          <div className="mt-8 rounded-xl border border-dashed border-slate-300 p-6 text-sm text-slate-500 text-center">No board members yet.</div>
        ) : (
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
            {items.map((b) => (
              <article key={b.id} className="rounded-2xl border border-slate-200 bg-white p-6" data-testid={`uni-board-card-${b.id}`}>
                <div className="flex items-start gap-4">
                  <div className="w-16 h-16 rounded-full bg-purple-100 flex items-center justify-center text-purple-900 font-display text-xl flex-shrink-0">
                    {b.headshot_url ? <img src={b.headshot_url} alt="" className="w-16 h-16 rounded-full object-cover" /> : (b.name || "B")[0]}
                  </div>
                  <div className="min-w-0">
                    <div className="font-display text-xl text-slate-900 leading-tight">{b.name}</div>
                    <div className="text-sm text-purple-900 mt-0.5">{b.position}</div>
                    <span className={`inline-block mt-1 text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full ${STATUS_TONE[b.status] || "bg-slate-100 text-slate-700"}`}>{b.status}</span>
                  </div>
                </div>
                {b.credentials && <div className="mt-3 text-xs text-slate-700 inline-flex items-center gap-1"><Award className="w-3 h-3 text-purple-900" />{b.credentials}</div>}
                {b.biography && <p className="mt-3 text-sm text-slate-700 leading-relaxed">{b.biography}</p>}
                <div className="mt-3 text-[11px] text-slate-500 flex items-center justify-between">
                  {b.appointment_date && <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" />Appointed {b.appointment_date.slice(0,10)}</span>}
                </div>
              </article>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
